import { queryString } from '../../../jsCore/utils/window'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import getRandomFacebookBotButtonMessage from './facebook-bot-button-messages'

const BLOCK_NAME = 'facebook-bot'
const DEFAULT_HREF = 'https://m.me/90minFootball'
const forceFacebookBotCount = parseInt(queryString.forceFacebookBot, 10) || 0

export default class FacebookBotComponent extends Component {
  render() {
    const { className, href, goToMessengerBot } = this.props
    const anchorProps = {
      className: [BLOCK_NAME, className].join(' '),
      onClick: goToMessengerBot,
      target: '_blank',
      rel: 'noopener',
      href,
    }
    const facebookBotAnchor = (_, key) =>
      <a {...anchorProps} key={key}>
        <div className={`${BLOCK_NAME}__message-wrap`}>
          {getRandomFacebookBotButtonMessage(BLOCK_NAME, key)}
        </div>
      </a>
    return forceFacebookBotCount
      ? <section>
          {Array.from(Array(forceFacebookBotCount), facebookBotAnchor)}
        </section>
      : facebookBotAnchor()
  }
}

const { string } = PropTypes

Object.assign(FacebookBotComponent, {
  propTypes: {
    className: string,
    href: string,
  },
  defaultProps: {
    href: DEFAULT_HREF,
  },
})



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/facebook_bot/components/facebookBotComponent.js